import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { WhyUs } from "@/components/WhyUs";
import { ContentSections } from "@/components/ContentSections";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { ChateauSelector } from "@/components/ChateauSelector";
import { CookieConsent } from "@/components/CookieConsent";
import { TrustIndicators } from "@/components/enhanced/TrustIndicators";
import { EnhancedSEOOptimizer } from "@/utils/enhancedSeoOptimizer";


const Index = () => {
  // Enhanced SEO data
  const seoData = EnhancedSEOOptimizer.generatePageSEO('home');

  return (
    <div className="min-h-screen">
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords.join(', ')}
        canonicalUrl={seoData.canonicalUrl}
        ogImage={seoData.ogImage}
        schema={seoData.schema}
      />
      <Header />
      <main>
        <Hero />
        <Services />
        <WhyUs />
        
        {/* Trust Indicators Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-display font-bold text-primary mb-4">
                Pourquoi nous faire confiance ?
              </h2>
              <p className="text-muted-foreground max-w-2xl mx-auto">
                Plus de 30 ans d'expérience dans l'événementiel pour des fêtes inoubliables en toute sécurité.
              </p>
            </div>
            <TrustIndicators />
          </div>
        </section>
        
        <ContentSections />
        {/* Section Aide au Choix */}
        <section className="py-16 bg-gradient-sky">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <ChateauSelector compact={true} />
            </div>
          </div>
        </section>
        <Contact />
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
};

export default Index;
